import { useState, useEffect } from "react";
const { buildQuestionLookup, isQuestionVisible } = require("../shared/progress");

export default function QuestionPaiement({ questionInfo, getNumberFiliereActif, getNumberCritereActif, sousCritereIndex, questionIndex, data, Lang, updateQuestionValue , checkPaymentExists , paymentExists }) {
    /* ------------------------------------------------------------ STATE ------------------------------------------------------------ */ 
    const [link, setLink] = useState("");
    const [mtt, setMtt] = useState([questionInfo.paiement, questionInfo.montant]);
    const [showPaymentReminder, setShowPaymentReminder] = useState(false);

    const currentPeriod = data?.data?.[getNumberFiliereActif];
    const questionLookup = buildQuestionLookup(currentPeriod);
    let visible = isQuestionVisible(questionInfo, {
        dataFiltres: currentPeriod?.filtres,
        questionLookup
    });
    const questions = data.data[getNumberFiliereActif].criteres[getNumberCritereActif].sousCriteres[sousCritereIndex].questions;

    /* ------------------------------------------------------------ DÉPENDANCES AUX AUTRES QUESTIONS ------------------------------------------------------------ */

    try {
        questions[questionIndex].visible = visible;
    } catch {
        
    }

    /* ------------------------------------------------------------ GÉNÉRATION DES DONNÉES UTILISATEUR ------------------------------------------------------------ */


    const mail = data.mail;

    const FirstName = data.data[getNumberFiliereActif].criteres[0].sousCriteres[0].questions[2].value;

    const LastName = data.data[getNumberFiliereActif].criteres[0].sousCriteres[0].questions[1].value;

    const Address1 = data.data[getNumberFiliereActif].criteres[0].sousCriteres[1].questions[0].value;

    const ZipCode = data.data[getNumberFiliereActif].criteres[0].sousCriteres[1].questions[2].code_postal || "";

    const City = data.data[getNumberFiliereActif].criteres[0].sousCriteres[1].questions[2].valueName || "";

    const CountryCode = data.data[getNumberFiliereActif].criteres[0].sousCriteres[1].questions[3].code || "";

    const CountryCodeMobilePhone = (data.data[getNumberFiliereActif].criteres[0].sousCriteres[1].questions[4].value || "")
        .match(/(\+\d+)/i)?.[1] || "";

    const MobilePhone = data.data[getNumberFiliereActif].criteres[0].sousCriteres[1].questions[5].value || "";


    /* ------------------------------------------------------------ MISE À JOUR DE L'ÉTAT DANS useEffect ------------------------------------------------------------ */

    useEffect(() => {
        setMtt([questionInfo.paiement, questionInfo.montant]);
    }, [questionInfo.paiement, questionInfo.montant]);

    useEffect(() => {
        const paidValue = paymentExists === true;
        updateQuestionValue(sousCritereIndex, questionIndex, paidValue);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paymentExists, sousCritereIndex, questionIndex]);

    useEffect(() => {
        if (paymentExists) {
            setShowPaymentReminder(false);
        }
    }, [paymentExists]);

    /* ------------------------------------------------------------ GÉNÉRATION DU LIEN DE PAIEMENT ------------------------------------------------------------ */
    useEffect(() => {
        try{
            if(mtt!== undefined){
                const params = new URLSearchParams({
                    mtt: mtt[0],
                    token: data.token || "",
                    mail,
                    FirstName,
                    LastName,
                    Address1,
                    ZipCode,
                    City,
                    CountryCode,
                    CountryCodeMobilePhone,
                    MobilePhone
                });
                setLink(`https://inscription.ices.fr/pay/JKSHFDS_jskz3.php/?${params.toString()}`);
            }
        } catch {
            //setLink("https://inscription.ices.fr/pay/JKSHFDS_jskz3.php/?mtt=apxch6dn56SHSD_egjs_869&mail=loq.charly@gmail.com&FirstName=Charly&LastName=LOQUET&Address1=1 rue nap&ZipCode=85000&City=France&CountryCode=250&CountryCodeMobilePhone=+33&MobilePhone=0771717712")
        }

    }, [mtt, data.token, mail, FirstName, LastName, Address1, ZipCode, City, CountryCode, CountryCodeMobilePhone, MobilePhone]); // Met à jour `link` lorsque ces variables changent
    
    /* ------------------------------------------------------------ AFFICHAGE ------------------------------------------------------------ */
    if (visible) {
        const reminderText2 = Lang === "en"
            ? "Before paying, please make sure your file is complete and correct.\nPlease review your documents one last time."
            : `En procédant au paiement, je comprend que mon dossier sera envoyé automatiquement. Si ce n'est pas déjà fait, merci de vous assurer de la conformité des informations fournies.

⚠️ Il ne sera plus possible de revenir en arrière.
`;
        return (
            <div className="question">
                <label className="questionTitle">
                    {questionInfo.etiquette} :{questionInfo.required === "required" ? " *" : ""}
                </label>

                <div className="QuestionHelp" dangerouslySetInnerHTML={{ __html: questionInfo.QuestionHelp }} />

                {paymentExists===true ? (
                    <h4>
                        {Lang === "en" ? "Already paid" : "✅ Paiement Effectué"}
                    </h4>
                ) : (
                    <>
                        {!showPaymentReminder ? (
                            <button
                                type="button"
                                disabled={!mtt[0]}
                                onClick={() => setShowPaymentReminder(true)}
                            >
                                {Lang === "en" ? "Pay" : "Payer les droits d'inscription"} ({mtt[1]}€)
                            </button>
                        ) : (
                            <div className="paymentReminder" role="status" aria-live="polite">
                                <p className="paymentReminderText">{reminderText2}</p>
                                <div className="paymentReminderActions">
                                    <a target="" rel="noreferrer" href={link}>
                                        <button type="button" disabled={!mtt[0]}>
                                            {Lang === "en" ? "Continue to payment" : "Continuer vers le paiement"}
                                        </button>
                                    </a>
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>
        );
    }

    return null;
}
